// extracted by mini-css-extract-plugin
module.exports = {"specialWrapper":"ExpandableBoxes_specialWrapper__wlvYt","box":"ExpandableBoxes_box__FeYZy","copy":"ExpandableBoxes_copy__HrrwA","oYauto":"ExpandableBoxes_oYauto__1i9vq"};